class Store {
    constructor() {
        this.pages = new Map();
        this.activeobjectid = "";
        this.activefileid = "";
    }
}
export const PwaPdfPageStore = new Store();
export const PwaFloatingPdfPageStore = new Store();
